(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footernew"]) return;
  try {
    
  /* Add jQuery for accordion functionality */
  $(document).ready(function () {
    $('.v-footer__block-navigation__title, .v-footer__block-logo-newsletter__title').on('click', function () {
      if ($(window).width() < 768) {
        var $this = $(this);
        var $content = $this.next();
        var $icon = $this.find('i');

        $content.slideToggle(300);
        $icon.toggleClass('fa-plus fa-minus');
      }
    });

    $(window).resize(function () {
      if ($(window).width() >= 768) {
        $('.v-footer__block-navigation__links, .v-footer__newsletter').css('display', 'block');
      } else {
        $('.v-footer__block-navigation__links, .v-footer__newsletter').css('display', 'none');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
